export default __webpack_public_path__ + "static/media/pvc.58f5d3c1.svg";